import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ORIGINTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.OriginType.Name')
    .minLength(1)
    .maxLength(50)
    .required()
    .build(),
];

export const ORIGINTYPE_CONFIG = {
  entityName: 'OriginType',
  localizationKey: 'Controlling::Entity.OriginType',
  fields: ORIGINTYPE_FIELDS,
  permission: 'ControllingStructural.OriginTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
